<style lang="stylus">
.image-display-grey-bg {
  height: 302px;
  text-align: center;
  background-color: #F1F1F1;
}

.image-display-black-bg {
  height: 254.25px;
  width: 452px;
  background-color: #2A2A2A;
  display: inline-block;
  margin: 24px;
}

.retake-photos {
  font-size: 16px;
  font-weight: 400;
  margin-top: 12px;
  margin-bottom: 48px;
  color: #747474;
}

.retake-photos-red-text {
  color: #8C1D40;
  text-decoration: underline;
  cursor: pointer;
}

.bulletin-points {
  margin-bottom: 12px;
  margin-left: 24px;
  font-weight: 400;
  font-size: 16px;
}

.display-photos-checkbox {
  margin-left: 15px;

  .v-input__slot {
    margin-bottom: 0px !important;
  }

  .v-input__details {
    display: none !important;
  }

  .v-label {
    color: rgba(0,0,0,.54) !important;
  }
}

.request-name-change {
  color: #8C1D40;
  text-decoration: underline;
}

.request-name-change:hover {
  text-decoration: underline;
}

@media (max-width: 1200px) {
  .image-display-grey-bg {
    margin-bottom: 32px;
  }
}

@media (max-width: 600px) {
  .captured-image {
    height: 369px;
    width: 290px;
    cursor: pointer;
    object-fit: fill;
  }

  .captured-image-display {
    margin-bottom: 24px;
  }

  .image-display-grey-bg {
    height: 419px;
    margin-bottom: 32px;
  }

  .image-display-black-bg {
    height: 371px;
  }

  .bulletin-points {
    margin: 0 28px 12px 14px;
  }

  .display-photos-checkbox {
    margin-left: 16px;
  }
}

@media (max-width: 375px) {
  .captured-image {
    // margin: 24px 210px 24px 24px;
    // width: 277px;
  }
}

@media (max-width: 360px) {
  .captured-image {
    margin: 24px 210px 24px 17px;
    width: 276px;
  }
}

@media (max-width: 320px) {
  .captured-image {
    width: 248px;
    margin: 24px 210px 24px 11px;
    object-fit: fill;
  }
}
</style>
<template>
  <div style="position: relative">
    <!-- Loading Overlay -->
    <v-overlay v-model="activeLoading" class="align-center justify-center" :persistent="true" contained>
      <v-progress-circular color="primary" indeterminate size="40" width="3" />
    </v-overlay>
    <v-row class="step-1-take-photo-bg" align-center justify="center" row wrap>
      <v-container class="container">
        <v-col cols="12" md="12" sm="12" style="background-color: #fff">
          <v-container class="container">
            <div class="take-your-photo">
              <span class="yellowCircle-take-photo">3&nbsp;</span>
              Review your photos
            </div>

            <v-row wrap justify="center">
              <v-col cols="12" sm="12" md="12" lg="5">
                <div class="image-display-grey-bg">
                  <div class="image-display-black-bg" v-if="!faceImage" />
                  <img :src="faceImage" class="captured-image captured-image-display" v-else />
                </div>
              </v-col>
              <v-col cols="12" lg="1" />
              <v-col cols="12" sm="12" md="12" lg="5">
                <div class="image-display-grey-bg">
                  <div class="image-display-black-bg" v-if="!idImage" />
                  <img :src="idImage" class="captured-image captured-image-display" v-else />
                </div>
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col cols="12" md="12">
                <div class="take-photo-steps">Photo requirements to check</div>

                <div style="margin-bottom: 12px" class="bulletin-points">
                  <div
                    style="
                      background-color: black;
                      width: 6px;
                      height: 6px;
                      border-radius: 5px;
                      margin-right: 10px;
                      display: inline-block;
                    "
                  />
                  Does the photo of you show your entire face?
                </div>
                <div class="bulletin-points">
                  <div
                    style="
                      background-color: black;
                      width: 6px;
                      height: 6px;
                      border-radius: 5px;
                      margin-right: 10px;
                      display: inline-block;
                    "
                  />
                  Does the photo of you match your photo ID?
                </div>
                <div class="bulletin-points">
                  <div
                    style="
                      background-color: black;
                      width: 6px;
                      height: 6px;
                      border-radius: 5px;
                      margin-right: 10px;
                      display: inline-block;
                    "
                  />
                  Can you easily read the name listed on your photo ID?
                </div>
                <div class="bulletin-points">
                  <div
                    style="
                      background-color: black;
                      width: 6px;
                      height: 6px;
                      border-radius: 5px;
                      margin-right: 10px;
                      display: inline-block;
                    "
                  />
                  Does the name on your ID match your account name:<strong>
                    {{ this.$conn.learnerData._firstName }} {{ this.$conn.learnerData._lastName }}</strong
                  >? If not, you can request a name change from your
                  <a
                    @click="(asuoDataLayerClick('idVerifiyStep3', '3'), openProfile())"
                    class="request-name-change"
                    target="_blank"
                    >Profile</a
                  >.
                </div>
                <v-col cols="12" md="5" style="border: 1px solid #dddddd" class="check-box-parent">
                  <v-checkbox
                    v-model="checkbox"
                    @change="asuoDataLayerClick('idVerifiyStep3', '0', {})"
                    class="check-box display-photos-checkbox"
                    color="black"
                    label="Yes, my photos meet the requirements."
                  />
                </v-col>

                <div class="retake-photos">
                  If not, you can
                  <span
                    class="retake-photos-red-text"
                    @click="
                      asuoDataLayerClick('idVerifiyStep3', '1', {});
                      retakePhotos();
                    "
                    >retake your photos</span
                  >.
                </div>
                <div class="nextButton" style="margin-bottom: 32.5px">
                  <v-btn
                    @click="
                      asuoDataLayerClick('idVerifiyStep3', '2', {});
                      submitPhotos();
                    "
                    :ripple="false"
                    variant="flat"
                    :disabled="!checkbox"
                    :class="!checkbox ? 'invalid-button' : ''"
                  >
                    <span style="padding-left: 6px">Submit</span>
                    <v-icon left style="margin: 0px 14px">mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <div class="take-photo-questions d-flex d-sm-none">
              <span style="font-weight: 900">Questions?</span>&nbsp;Please&nbsp;
              <span
                style="color: #8c1d40; text-decoration: underline"
                v-on:click="
                  asuoDataLayerClick('idVerifiyStep1', '5', {});
                  gotoFAQ();
                "
                >read our FAQ</span
              >
              to view common questions.
            </div>
          </v-container>
        </v-col>
      </v-container>
    </v-row>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { Logger } from '../mixins/logger';

export default defineComponent({
  emits: ['goToStep'],

  data() {
    return {
      checkbox: false,
      faceImage: '',
      idImage: ''
    };
  },

  mixins: [DataLayerMixin, AjaxLoader, Logger],

  methods: {
    openProfile() {
      this.$router.push({ name: 'profile' });
    },
    async submitPhotos() {
      if (this.faceImage && this.idImage && this.checkbox) {
        let time = new Date().toISOString();

        let user = {
          learnerId: this.$conn.learnerData._learnerId,
          firstName: this.$conn.learnerData._firstName,
          lastName: this.$conn.learnerData._lastName,
          face_photo: this.faceImage,
          id_photo: this.idImage,
          time,
          source: 'EA'
        };

        await this.$conn
          .postIDVerificationImages(user)
          .then(async (res) => {
            this.logInfo('postIDVerificationImages', res);

            let data = {
              idVerify: 'submitted',
              idVerifyDate: new Date().toISOString().slice(0, 10)
            };
            await this.$conn.updateIDVerify(data);
          })
          .catch((err) => {
            this.logError('postIDVerificationImages', err);
          })
          .finally(() => {});

        this.$emit('goToStep', { step: 4 });
      }
    },
    retakePhotos() {
      this.$emit('goToStep', { step: 1 });
    }
  },

  created() {
    const userStore = useUserStore();
    this.faceImage = userStore.IDVerifyHighResCapturedFaceImage;
    this.idImage = userStore.IDVerifyHighResCapturedIDPhoto;
  }
});
</script>
